import {
    handleActions,
    Action,
} from 'redux-actions';
import {
    QCTabsPayload,
    ACTIVE_QC_TAB_SET,
} from './QCTabsActions';
import {TabIndex} from '../QCTabsTypes';

export interface QCTabsState {
    activeTab: TabIndex;
}

export const setCurrentTab = (state: QCTabsState, action: Action<QCTabsPayload>): QCTabsState => {
    const {payload} = action;
    const {activeTab} = payload;
    
    return {
        activeTab,
    };
};

export const initialState: QCTabsState = {
    activeTab: TabIndex.QCReport,
};

const handlers = {
    [ACTIVE_QC_TAB_SET]: setCurrentTab,
};

type CombinedPayloads = QCTabsPayload;

export default handleActions<QCTabsState, CombinedPayloads>(handlers, initialState);
